import React from 'react';
import { Link } from 'react-router-dom';

export type BreadcrumbItem = {
  label: string;
  to?: string;
  active?: boolean;
};

type BlogBreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
};

const BlogBreadcrumbs: React.FC<BlogBreadcrumbsProps> = ({ items, className = '' }) => (
  <div className={`flex items-center gap-1.5 min-w-0 text-[10px] sm:text-[14px] font-title font-medium ${className}`}>
    {items.map((item, index) => (
      <React.Fragment key={`${item.label}-${index}`}>
        {item.to ? (
          <Link 
            to={item.to} 
            className={`shrink-0 transition-colors hover:text-gray-900 ${item.active ? 'text-gray-900' : 'text-gray-400'}`}
          >
            {item.label}
          </Link>
        ) : (
          <span
            className={`shrink-0 ${item.active ? 'text-gray-900 truncate max-w-[160px] sm:max-w-[280px]' : 'text-gray-400'}`}
          >
            {item.label}
          </span>
        )}
        {index < items.length - 1 && (
          <span className="text-gray-300 px-0.5" aria-hidden>
            &gt;
          </span>
        )}
      </React.Fragment>
    ))}
  </div>
);

export default BlogBreadcrumbs;
